import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Field, change, reduxForm, formValueSelector } from 'redux-form';
import {withTranslation} from "react-i18next";
import renderHiddenCommentersInput from './components/renderHiddenCommentersInput';
import { prepareBlogSettingsForm } from '../../../redux/actions/blogsActions';
import { connect } from 'react-redux';
import config from '../../../config'

const selector = formValueSelector('blog_settings');

class HiddenCommenters extends PureComponent {

  render() {
    const { handleSubmit, blog, t, pushBots, getHiddenCommenters } = this.props;

    return (
      <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('settings.hidden_commenters.title')}</h5>
              <h5 className="subhead">{t('settings.hidden_commenters.subtitle')}</h5>
            </div>
            <Field
                name="hidden_commenters"
                format={null}
                addTagText={t('settings.hidden_commenters.add_username')}
                component={renderHiddenCommentersInput}
            />
            <br/>
            <h5 className="subhead quick-add__title" onClick={() => {
              const usernames = getHiddenCommenters();
              const newValues = usernames.concat(config.BOTS)
              return pushBots([...new Set(newValues)]);
            }}>{t('settings.hidden_commenters.quick_add')}</h5>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getHiddenCommenters: () => selector(state, 'hidden_commenters')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    pushBots: (bots) => { dispatch(change('blog_settings', 'hidden_commenters', bots)) }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'blog_settings', // a unique identifier for this form
  enableReinitialize: true
})(withTranslation('dashboard')(HiddenCommenters)));
